(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const lenisSrc = document.currentScript && document.currentScript.dataset.lenisSrc;

  const boot = (Lenis) => {
    if (reducedMotion.matches || !finePointer.matches || typeof Lenis !== 'function') return;

    const pageWrapper = document.querySelector('.page-wrapper');
    const desktopLayout = window.matchMedia('(min-width: 990px)');
    const usesPageWrapper = pageWrapper && desktopLayout.matches;
    const scrollWrapper = usesPageWrapper ? pageWrapper : window;
    const scrollContent = usesPageWrapper
      ? document.querySelector('#MainContent') || pageWrapper
      : document.documentElement;

    const lenis = new Lenis({
      wrapper: scrollWrapper,
      content: scrollContent,
      eventsTarget: scrollWrapper,
      duration: 1.2,
      smoothWheel: true,
      autoRaf: false,
    });

    window.itccLenis = lenis;
    window.dispatchEvent(new CustomEvent('lenis:init', { detail: { lenis } }));

    let frameId = 0;
    let running = false;
    const resizeObserver = new ResizeObserver(() => lenis.resize());

    if (scrollContent instanceof Element) resizeObserver.observe(scrollContent);
    const footer = pageWrapper?.querySelector('footer');
    if (footer) resizeObserver.observe(footer);

    const refresh = () => lenis.resize();
    window.addEventListener('load', refresh, { once: true });
    document.fonts?.ready.then(refresh);

    const stopRaf = () => {
      if (!running) return;
      window.cancelAnimationFrame(frameId);
      running = false;
      frameId = 0;
    };

    const raf = (time) => {
      lenis.raf(time);
      if (running) frameId = window.requestAnimationFrame(raf);
    };

    const startRaf = () => {
      if (running) return;
      running = true;
      frameId = window.requestAnimationFrame(raf);
    };

    let idleTimer = 0;
    const bump = () => {
      startRaf();
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(stopRaf, 1500);
    };

    const eventsTarget = scrollWrapper === window ? window : scrollWrapper;
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => {
      eventsTarget.addEventListener(type, bump, { passive: true });
    });

    reducedMotion.addEventListener?.('change', (event) => {
      if (!event.matches) return;
      stopRaf();
      resizeObserver.disconnect();
      lenis.destroy();
      delete window.itccLenis;
    });

    window.addEventListener(
      'pagehide',
      () => {
        stopRaf();
        resizeObserver.disconnect();
        lenis.destroy();
        delete window.itccLenis;
      },
      { once: true }
    );
  };

  const loadLenis = () =>
    new Promise((resolve, reject) => {
      if (typeof window.Lenis === 'function') {
        resolve(window.Lenis);
        return;
      }
      if (!lenisSrc) {
        reject(new Error('missing lenis src'));
        return;
      }
      const script = document.createElement('script');
      script.src = lenisSrc;
      script.async = true;
      script.onload = () => resolve(window.Lenis);
      script.onerror = reject;
      document.head.appendChild(script);
    });

  const schedule = () => {
    if (!finePointer.matches || reducedMotion.matches) return;
    loadLenis()
      .then((Lenis) => boot(Lenis))
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
